import React from 'react';
import { Typography, DialogContent, Grid, Stack, IconButton } from '@mui/joy';
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';

function ErrorPopUp(props) {

    return (
        <Modal open={props.show} onClose={props.onHide} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} disableScrollLock={true}>
            <ModalDialog sx={{ opacity: props.show ? 1 : 0, transition: `opacity 300ms` }}>
                <DialogContent>
                    <Stack spacing={3} sx={{ maxWidth: 300 }} justifyContent={"center"} alignContent={"center"}>
                        <IconButton variant='plain' color='primary'>
                            <span
                                style={{ display: 'inline-block' }}
                            >
                                <ErrorOutlineOutlinedIcon
                                    style={{ fontSize: "5pc" }}
                                    sx={{
                                        animation: 'shake 0.5s',
                                        '@keyframes shake': {
                                            '0%': { transform: 'translateX(0)' },
                                            '20%': { transform: 'translateX(-8px)' },
                                            '40%': { transform: 'translateX(8px)' },
                                            '60%': { transform: 'translateX(-8px)' },
                                            '80%': { transform: 'translateX(8px)' },
                                            '100%': { transform: 'translateX(0)' },
                                        },
                                    }}
                                />
                            </span>
                        </IconButton>
                        <Typography color="danger" level="body-lg" sx={{ textAlign: 'center' }} noWrap={false}>{props.data}</Typography>
                    </Stack>
                </DialogContent>
            </ModalDialog>
        </Modal>
    );
}
export default ErrorPopUp;